var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.55 34.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8c9fb4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.18,0h-12.45c-.15,0-.29.09-.35.23-.06.14-.03.3.08.41l3.29,3.29-7.35,7.35c-.15.15-.15.39,0,.53.15.15.39.15.53,0l7.61-7.61c.15-.15.15-.39,0-.53l-2.91-2.91h11.17v11.17l-2.91-2.91c-.15-.15-.39-.15-.53,0l-7.61,7.61c-.15.15-.15.39,0,.53.07.07.17.11.27.11s.19-.04.27-.11l7.35-7.35,3.29,3.29c.11.11.27.14.41.08.14-.06.23-.2.23-.35V.38c0-.21-.17-.38-.38-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.61,17.22v-8.68c0-.21-.17-.38-.38-.38H3.55c-.15,0-.29.09-.35.23-.06.14-.03.3.08.41l2.21,2.21L.11,16.4c-.15.15-.15.39,0,.53.15.15.39.15.53,0l5.65-5.65c.15-.15.15-.39,0-.53l-1.84-1.84h7.4v7.4l-1.84-1.84c-.15-.15-.39-.15-.53,0L.11,23.85c-.15.15-.15.39,0,.53.07.07.17.11.27.11s.19-.04.27-.11l9.11-9.11,2.21,2.21c.11.11.27.14.41.08.14-.06.23-.2.23-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.65,22.37L.11,31.91c-.15.15-.15.39,0,.53.07.07.17.11.27.11s.19-.04.27-.11l9.54-9.54c.15-.15.15-.39,0-.53-.15-.15-.39-.15-.53,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.57,4.77c.1,0,.19-.04.27-.11L15.86.64c.15-.15.15-.39,0-.53-.15-.15-.39-.15-.53,0l-4.02,4.02c-.15.15-.15.39,0,.53.07.07.17.11.27.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.91,16.86l-4.02,4.02c-.15.15-.15.39,0,.53.07.07.17.11.27.11s.19-.04.27-.11l4.02-4.02c.15-.15.15-.39,0-.53-.15-.15-.39-.15-.53,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.87,19.3c-3.67,0-6.44,1.24-6.44,2.89v9.77c0,1.65,2.77,2.89,6.44,2.89s6.44-1.24,6.44-2.89v-9.77c0-1.65-2.77-2.89-6.44-2.89ZM24.56,31.97c0,1.01-2.34,2.14-5.69,2.14s-5.69-1.13-5.69-2.14v-1.84c1.06.9,3.16,1.49,5.69,1.49s4.63-.59,5.69-1.49v1.84ZM24.56,28.73c0,1.01-2.34,2.14-5.69,2.14s-5.69-1.13-5.69-2.14v-1.84c1.06.9,3.16,1.49,5.69,1.49s4.63-.59,5.69-1.49v1.84ZM24.56,25.49c0,1.01-2.34,2.14-5.69,2.14s-5.69-1.13-5.69-2.14v-1.89c1.06.9,3.16,1.49,5.69,1.49s4.63-.59,5.69-1.49v1.89ZM18.87,24.34c-3.35,0-5.69-1.13-5.69-2.14s2.34-2.14,5.69-2.14,5.69,1.13,5.69,2.14-2.34,2.14-5.69,2.14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.93b4cd462e4d71c3fb3267d1aa8f7579.svg";
export { ForwardRef as ReactComponent };